<template>
  <a-modal
    :visible="visible"
    :cancelText="cancelText"
    :okText="okText"
    @ok="handleOk('ruleForm')"
    @cancel="handleCancel"
    :footer="null"
    centered
    :destroyOnClose="true"
    :maskClosable="false"
    :width="500"
  >
    <div v-if="currentStep===0" class="unverify">
      <div class="verify-title">{{ title }}</div>
      <a-form-model
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :colon="false"
        v-bind="layout"
        style="margin-left: 10px;"
      >
        <a-form-model-item has-feedback label="单位名称" prop="worksheetCompanyName">
          <a-input
            v-model="ruleForm.worksheetCompanyName"
            placeholder="请输入单位名称"
            style="width: 344px;"
          />
        </a-form-model-item>
        <a-form-model-item has-feedback label="联系人" prop="worksheetContacter">
          <a-input
            v-model="ruleForm.worksheetContacter"
            placeholder="请输入联系人真实姓名"
            style="width: 344px;"
          />
        </a-form-model-item>
        <a-form-model-item has-feedback label="邮箱" prop="worksheetEmail">
          <a-input
            v-model="ruleForm.worksheetEmail"
            placeholder="请输入常用邮箱"
            style="width: 344px;"
          />
        </a-form-model-item>
      </a-form-model>
      <div class="actions">
        <a-button @click="handleCancel">
          取消
        </a-button>
        <a-button
          type="primary"
          @click="handleOk('ruleForm')"
          style="margin-left: 10px;"
        >
          提交
        </a-button>
      </div>
    </div>
    <div v-if="currentStep===1" class="finishVerify">
      <a-result title="认证成功">
        <template #icon>
          <eco-icon name="checkmark1" :size="54"></eco-icon>
        </template>
        <template #extra>
          <a-button key="buy" type="primary" @click="newWorksheet">
            立即创建工单
          </a-button>
          <a-button key="console" style="margin-left:102px;" @click="handleCancel">
            暂不创建
          </a-button>
        </template>
      </a-result>
    </div>
  </a-modal>
</template>

<script>
import {verfiyCompany} from '@/request/worksheet.js'
import {
  user, model
} from "eco-cli";
import {updateInfo} from '../../../App.vue'
const {
  getToken,
  getInfo,
  setToken
} = user
const User = model.UserInfo;

export default {
  data() {
    return {
      title: '身份认证',
      visible: false,
      cancelText: '取消',
      okText: '提交',
      currentStep: 0,
      layout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 14,
        },
      },
      ruleForm: User.blank(),
      rules: {
        worksheetCompanyName: [
          {
            required: true,
            message: '请输入单位名称',
            trigger: 'change',
          },
          {
            max: 50,
            message: "输入内容字符已达上限50个字符",
            trigger: ["blur", "change"]
          }
        ],
        worksheetContacter: [
          {
            required: true,
            message: '请输入联系人',
            trigger: 'change',
          },
          {
            max: 5,
            message: "输入内容字符已达上限5个字符",
            trigger: ["blur", "change"]
          }
        ],
        worksheetEmail: [
          {
            required: true,
            message: '请输入常用邮箱',
            trigger: 'change',
          },
          {
            max: 320,
            message: "邮箱长度超出限制！",
            trigger: ["blur", "change"]
          },
          {
            pattern: /^[a-z0-9A-Z][- | a-z0-9A-Z . _]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            message: "请输入正确的邮箱地址！",
            trigger: "blur",
          }
        ],
      },
      token: '',
      headers: {},
      userInfo: {}
    }
  },
  mounted () {
    getToken().then((res) => {
      this.token = res;
      this.headers = {
        "X-Access-Token": res
      };
    })
    getInfo(true).then(res => {
      console.log("currentUser", res)
      this.userInfo = res;
    });
  },
  methods: {
    // 身份认证
    handleOk(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          verfiyCompany(this.ruleForm).then(()=>{
            this.currentStep = 1;
            this.userInfo.worksheetCompanyName = this.ruleForm.worksheetCompanyName;
            this.userInfo.worksheetContacter = this.ruleForm.worksheetContacter;
            this.userInfo.worksheetEmail = this.ruleForm.worksheetEmail;
            
            this.userInfo.isWorksheetVerify = true;
            setToken(this.token, this.userInfo);
            updateInfo()
            this.$emit('ok')
            console.log(`submit`)
          }).catch((err)=>{
            this.$message.error(`${err.message}`)
          })
        } else {
          return false
        }
      })
    },
    // 新建表单
    newWorksheet() {
      this.$router.push('/worksheet/new');
    },
    // 取消
    handleCancel() {
      this.visible = false
      this.ruleForm = {}
    },
  },
}
</script>

<style lang="scss" scoped>
.ant-result {
  padding: 0;
  .ant-result-icon {
    margin-bottom: 10px;
  }
  .ant-result-extra {
    margin-top: 38px;
    margin-bottom: 18px;
  }
}

.unverify {
  .verify-title {
    font-size: 18px;
    font-weight: 600;
    color: #222222;
    line-height: 25px;
    margin-left: 11px;
    margin-bottom: 33px;
  }
  .actions {
    margin-top: 34px;
    margin-bottom: 18px;
    padding: 0px 24px;
    display: flex;
    justify-content: flex-end;
  }
}
.finishVerify {
  margin-top: 44px;
}
</style>
